var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 390,
    viewBox: "0 0 360 390",
    role: "img",
    "aria-label": "MangroveCollect",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MangroveCollect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E713B",
    d: "M150 12 C112 43 117 89 150 128 C183 88 187 43 150 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E713B",
    d: "M46 69 C88 61 126 86 132 135 C85 130 50 109 46 69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E713B",
    d: "M254 69 C212 61 174 86 168 135 C215 130 250 109 254 69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E713B",
    d: "M6 136 C44 103 85 109 116 151 C76 178 35 175 6 136Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E713B",
    d: "M294 136 C256 103 215 109 184 151 C224 178 265 175 294 136Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 136 V206 M111 157 C134 161 150 180 150 205 M189 157 C166 161 150 180 150 205 M150 201 C148 237 46 238 34 283 M150 201 C152 237 254 238 266 283 M150 204 V306 M150 215 C116 232 93 262 88 305 M150 215 C184 232 207 262 212 305",
    fill: "none",
    stroke: "#163F30",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 300,
    r: 18,
    fill: "none",
    stroke: "#337889",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 329,
    r: 18,
    fill: "none",
    stroke: "#337889",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 300,
    r: 18,
    fill: "none",
    stroke: "#337889",
    strokeWidth: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.7241f83d4f077c4f306249460c95c5ea.svg";
export { ForwardRef as ReactComponent };